import { useState, useEffect, useRef, useMemo } from 'react'
import styled, { css } from 'styled-components'
import useTheme from 'hooks/useTheme'
import { BoxProps, IconSort, Text, Flex, InputGroup, SearchIcon, Input } from '@pancakeswap/uikit'
import { Brandtype } from 'state/giftCards/type'
import { useDispatch } from 'react-redux'
import { fetchListProvinceByBrandId } from 'state/giftCards/actions'
import { AppDispatch } from 'state'
import List from 'rc-virtual-list';
import LazyLoad  from 'react-lazyload';

const DropDownHeader = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0px 16px;
    transition: border-radius 0.15s;
    color: #fdb533;
    gap: 1rem;
    > svg {
        fill: #fff !important;
    }

    @media screen and (max-width: 600px) {
        padding: 0 10px;
        width: 80%;
        font-size: 12px;
    }
`
const CsText = styled(Text)`
    font-size: 16px;
    @media screen and (max-width: 600px) {
        font-size: 15px;
    }
`

const DropDownListContainer = styled.div`
    width: 180px;
    height: 100%;
    max-height: 250px;
    padding: 0;
    position: absolute;
    overflow-y: auto;
    overflow-x: hidden;
    z-index: ${({ theme }) => theme.zIndices.dropdown};
    transition: transform 0.15s, opacity 0.15s;
    transform: scaleY(0);
    transform-origin: top;
    opacity: 0;
    box-sizing: border-box;
    box-shadow: 0px 8px 28px 0px rgba(66, 66, 66, 0.10);
`

const DropDownContainer = styled.div<{ isOpen: boolean; width: number; height: number }>`
    cursor: pointer;
    position: relative;
    width: 100%;
    height: 48px;
    border-radius: 12px;
    box-sizing: border-box;
    background-color: transparent;
    border: 1px solid ${({ theme }) => theme.colors.cardBorder};
    ${({ theme }) => theme.mediaQueries.sm} {
        min-width: 100px;
    }
    ${(props) =>
        props.isOpen &&
        css`
            ${DropDownListContainer} {
                height: auto;
                transform: scaleY(1);
                opacity: 1;
                border-top-width: 0;
                width: 100%;
                background: ${({ theme }) => theme.colors.background};
                top: 49px;
                border-radius: 12px;
            }
        `}
`

const DropDownList = styled.ul`
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    z-index: ${({ theme }) => theme.zIndices.dropdown};
`

const ListItem = styled.li`
    list-style: none;
    display:flex;
    padding: 8px 16px;
    border-radius: 0px;
`

export interface SelectProps extends BoxProps {
    options: Brandtype[] | any[],
    onOptionChange?: (option: any | number) => void
    placeHolderText?: string
    defaultOptionIndex?: number,
    defaultValue?: any,
    isDefaultBrand:boolean,
    setIsDefaultBrand:(newValues: boolean) => void,
    isLoading:boolean
}

export interface OptionProps {
    name?: string,
    image?: string,
    images?: string,
    title?:string,
    id?:number
}

const SelectWidthImg: React.FunctionComponent<React.PropsWithChildren<SelectProps>> = ({
    options,
    onOptionChange,
    defaultOptionIndex,
    placeHolderText,
    defaultValue,
    isDefaultBrand,
    setIsDefaultBrand,
    isLoading,
    ...props
}) => {
    const dispatch = useDispatch<AppDispatch>()
    const containerRef = useRef(null)
    const dropdownRef = useRef(null)
    const [isOpen, setIsOpen] = useState(false)
    const [optionSelected, setOptionSelected] = useState(false)
    const [selectedOptionIndex, setSelectedOptionIndex] = useState(defaultOptionIndex)
    const [containerSize, setContainerSize] = useState({ width: 0, height: 0 })
    const [searchQuery, setSearchQuery] = useState('')
    const searchListBrand = useMemo(() => {
        const listItem = [...options]
        if (searchQuery !== '') {
            return listItem?.filter((item) => item?.title?.toLowerCase()?.includes(searchQuery?.toLowerCase()))
        }
        return listItem
    }, [options, searchQuery])
    const { theme } = useTheme()
    const toggling = (event: React.MouseEvent<HTMLDivElement>) => {
        if (options.length >= 1) {
            setIsOpen(!isOpen)
        }
        event.stopPropagation()
    }

    const onOptionClicked = (selectedIndex: number) => async () => {
        setSelectedOptionIndex(selectedIndex)
        setIsDefaultBrand(false)
        setIsOpen(false)
        setOptionSelected(true)
        await dispatch(fetchListProvinceByBrandId({brandId: selectedIndex?.toString()}))

        if (onOptionChange) {
            onOptionChange(selectedIndex)
        }
    }
    const handleClickOutside = () => {
        if (containerRef.current && !containerRef.current.contains(document.activeElement)) {
            setIsOpen(false)
        }
    }

    useEffect(() => {
        setContainerSize({
            width: dropdownRef.current.offsetWidth, // Consider border
            height: dropdownRef.current.offsetHeight,
        })

        document.addEventListener('click', handleClickOutside)
        return () => {
            document.removeEventListener('click', handleClickOutside)
        }
    }, [])

    const handleChangeBrand = (evt) => {
        const values = evt.target.value
        const replace = values.replace(/[.*+?^${}()|[\]\\!@#%&_~]/g, "");
        setSearchQuery(replace)
    }
    const findActiveItem = options?.find((item) => item?.id?.toLowerCase() === selectedOptionIndex?.toString()?.toLocaleLowerCase() )
    return (
        <>
            <DropDownContainer isOpen={isOpen} {...props} ref={containerRef} {...containerSize}>
                {containerSize.width !== 0 && (
                    <DropDownHeader onClick={toggling}>
                        {
                            isLoading ? <Text>Loading...</Text> :
                            <>
                                {!optionSelected && placeHolderText && !defaultValue ?
                                    <CsText color={!optionSelected && placeHolderText ? 'text' : undefined}>
                                    {placeHolderText}
                                    </CsText>
                                    :
                                    <>
                                        <CsImg>
                                            <img src={!optionSelected && placeHolderText ?  isDefaultBrand ? '/images/logo/noLogo.png' : defaultValue?.images : findActiveItem === undefined ? '/images/logo/noLogo.png' : isDefaultBrand ? '/images/logo/noLogo.png' : findActiveItem?.images } alt="" />
                                        </CsImg>
                                        <CsText color={!optionSelected && placeHolderText ? 'text' : undefined}>
                                            {!optionSelected && placeHolderText ? isDefaultBrand ? 'Chọn thương hiệu' : defaultValue?.title : options?.length === 0 ? 'Không có thương hiệu' : findActiveItem === undefined ? 'Chọn thương hiệu' : isDefaultBrand ? 'Chọn thương hiệu' : findActiveItem?.title }
                                        </CsText>
                                    </>
                                }
                            </>
                        }
                        
                    </DropDownHeader>
                )}
                <Flex position="absolute" right="16px" top="13px">
                    <IconSort color="black" onClick={toggling} style={{ transform: isOpen && 'rotate(180deg)' }} />
                </Flex>
                <DropDownListContainer>
                    <Flex width="100%" height="auto">
                        <InputGroup startIcon={<SearchIcon />} mb="2px" scale="sm" isHiddenBorder>
                            <Input type="text" placeholder='Tìm kiếm' onChange={(e) => handleChangeBrand(e)} />
                        </InputGroup>
                    </Flex>
                    <Flex width="100%" borderBottom={`1px solid ${theme.colors.backgroundTab}`} />
                    <DropDownList ref={dropdownRef}>
                        <List data={searchListBrand?.length > 0 ? searchListBrand : []} height={200} itemHeight={30} itemKey="id">
                                {(item, index) => {
                                    return(
                                        <ListItem onClick={onOptionClicked(item?.id)} key={item?.title}>
                                                <CsLazyLoad>
                                                    <CsImg>
                                                        <img src={item?.images || '/images/logo/noLogo.png'} alt={item?.title} />
                                                    </CsImg>
                                                    <CsText ml="1rem" color={index === selectedOptionIndex ? "primary" : "text"}>{item?.title}</CsText>
                                                </CsLazyLoad>
                                        </ListItem>
                                    )
                                }}
                        </List>
                    </DropDownList>
                </DropDownListContainer>
            </DropDownContainer>
        </>
    )
}
const CsLazyLoad = styled(LazyLoad)`
    display: flex;
    width: 100%;
`

const CsImg = styled(Flex)`
    width: 28px;
    height: 28px;
    img{
        object-fit: contain;
    }
`
export default SelectWidthImg

